import { useEffect, useState } from 'react';

export default function SplashScreen() {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const hidePrerender = requestAnimationFrame(() => {
      document.getElementById('app-splash-prerender')?.classList.add('in-splash-prerender--hide');
    });

    const timer = window.setTimeout(() => setHidden(true), 800);

    return () => {
      cancelAnimationFrame(hidePrerender);
      window.clearTimeout(timer);
    };
  }, []);

  return (
    <div className={'in-splash' + (hidden ? ' in-splash--hidden' : '')}>
      <div className="in-splash__logo">
        <span className="in-logo in-logo--lg">
          (in)nova
          <span className="in-logo__now in-splash__now">now</span>
        </span>
      </div>
    </div>
  );
}
